<template>
  <v-app>
    <CoreCookieBanner />
    <CoreHeader />
    <CoreSearch v-if="isDesktop" />
    <slot />
    <CoreFooter class="mt-auto" />
    <CoreLineStage />
  </v-app>
</template>

<script setup lang="ts">
import { useContextStore } from 'src/store'
import CoreHeader from 'src/layouts/core-layout/components/CoreHeader/CoreHeader.vue'
import CoreSearch from 'src/layouts/core-layout/components/CoreSearch/CoreSearch.vue'
import CoreFooter from 'src/layouts/core-layout/components/CoreFooter/CoreFooter.vue'
import CoreCookieBanner from 'src/layouts/core-layout/components/CoreCookieBanner/CoreCookieBanner.vue'
import CoreLineStage from 'src/layouts/core-layout/components/CoreLineStage/CoreLineStage.vue'

const { context } = useContextStore()
const isDesktop = context.flavour !== 'mobile'
</script>
